
// reactstrap components
import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Pagination,
  PaginationItem,
  PaginationLink,
  Progress,
  Table,
  Container,
  Row,
  UncontrolledTooltip
} from "reactstrap";
// core components
import Header from "components/Headers/Header.js";
import { useAccount } from "flow/flowContext";
import { useEffect, useState } from "react";
import { getAccountData } from "flow/scripts/account";
import PortfolioManagerHeader from "components/Headers/PortfolioManagerHeader";

const PortfolioManager = () => {

  const { address, isConnected, disconnect, connect } = useAccount();
  const [accountData, setAccountData] = useState(null);


  const fetchAccountData = async () =>{
    const accountData = await getAccountData(address)
    setAccountData(accountData)
  }

  useEffect(() => {
    fetchAccountData()
  }, [])



  return (
    <>
      <PortfolioManagerHeader accountData={accountData}/>
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <Card className="shadow" >
              <CardHeader className="border-0">
                <h3 className="mb-0">TOKENS</h3>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Name</th>
                    <th scope="col">Amount</th>

                    
                  </tr>
                </thead>
                <tbody>
                {accountData && accountData?.tokens?.map((token) =>{
                      return(
                        <>
                        <tr>
                    <th scope="row">
                      <Media className="align-items-center">
                      
                        <Media>
                          <span className="mb-0 text-sm">
                          {token.name}
                          </span>
                        </Media>
                      </Media>
                    </th>
                   <td>{token.amount}</td>
                    
                    <td className="text-left">
                      <UncontrolledDropdown>
                        <DropdownToggle
                          className="btn-icon-only text-light"
                          href="#pablo"
                          role="button"
                          size="sm"
                          color=""
                          onClick={(e) => e.preventDefault()}
                        >
                        <i className="fas fa-ellipsis-v" />
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu-arrow" right>
                          <DropdownItem
                            href="#pablo"
                            onClick={(e) => {
                              e.preventDefault()
                            }}
                          >
                            Send
                          </DropdownItem>
               
                          
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </td>
                  </tr>
                        </>
                      )
                    })}
                </tbody>
              </Table>
            </Card>
          </div>
        </Row>
        {/* Dark table */}
        <Row className="mt-5">
          <div className="col">
            <Card className="bg-default shadow">
              <CardHeader className="bg-transparent border-0">
                <h3 className="text-white mb-0">NFTs</h3>
              </CardHeader>
              <Table
                className="align-items-center table-dark table-flush"
                responsive
              >
                <thead className="thead-dark">
                <tr>
                    <th scope="col">Name</th>
                    <th scope="col">Quantity</th>

                  </tr>
                </thead>
                <tbody>
                {accountData && accountData?.nfts?.map((nft) =>{
                      return(
                        <>
                        <tr>
                              <th scope="row">
                                <Media className="align-items-center">
                                
                                  <Media>
                                    <span className="mb-0 text-sm">
                                    {nft.name}
                                    </span>
                                  </Media>
                                </Media>
                              </th>
                              <td>{nft.quantity}</td>
                              <td className="text-left">
                                <UncontrolledDropdown>
                                  <DropdownToggle
                                    className="btn-icon-only text-light"
                                    href="#pablo"
                                    role="button"
                                    size="sm"
                                    color=""
                                    onClick={(e) => e.preventDefault()}
                                  >
                                  <i className="fas fa-ellipsis-v" />
                                  </DropdownToggle>
                                  <DropdownMenu className="dropdown-menu-arrow" right>
                                    <DropdownItem
                                      href="#pablo"
                                      onClick={(e) => {
                                        e.preventDefault()
                                      }}
                                    >
                                      Send
                                    </DropdownItem>
                        
                                    
                                  </DropdownMenu>
                                </UncontrolledDropdown>
                              </td>
                  </tr>
                        </>
                      )
                    })}

                  
                  
                </tbody>
              </Table>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default PortfolioManager;
